export default "__VITE_ASSET__FGQHsVgR__"